/* ============================================================================
   ZARWANA PROTOTYPE — CATALOG (PLP) filters, sort, grid density
   Supports URL params:  ?collection=<key>   ?wishlist=1
   ========================================================================== */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const params = new URLSearchParams(location.search);
  const wishlistMode = params.get("wishlist") === "1";
  let presetCollection = params.get("collection");
  /* Native /collections/<handle> URLs (from Shopify navigation etc.) preset
     the matching derived category filter — resolved in setup() once the
     catalog has loaded. */
  const pathHandle = (location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1];
  const presetTag = params.get("tag");                    // new | bestseller (mega-menu "Featured")
  const presetMin = params.get("min");                    // mega-menu "By Price"
  const presetMax = params.get("max");
  const presetSort = params.get("sort");

  const WEIGHT_BANDS = [
    { label: "0 - 8 g", min: 0, max: 8 },
    { label: "8 - 14 g", min: 8, max: 14 },
    { label: "14 - 20 g", min: 14, max: 20 },
    { label: "20 - 26 g", min: 20, max: 26 },
  ];

  const PRICE_BANDS = [
    { label: "Under &#8377;5,000", min: 0, max: 5000 },
    { label: "&#8377;5,001 &ndash; &#8377;10,000", min: 5000, max: 10000 },
    { label: "&#8377;10,001 &ndash; &#8377;15,000", min: 10000, max: 15000 },
    { label: "&#8377;15,001 &ndash; &#8377;25,000", min: 15000, max: 25000 },
    { label: "&#8377;25,001 &ndash; &#8377;50,000", min: 25000, max: 50000 },
    { label: "&#8377;50,001 &ndash; &#8377;1,00,000", min: 50000, max: 100000 },
    { label: "Above &#8377;1,00,000", min: 100000, max: Infinity },
  ];

  const MORE_LIMIT = 5;                    // rows shown before the "N more" toggle
  let hasWeightData = false;               // set in setup()
  let PURITIES = [];                       // discovered in setup()

  const state = {
    collections: new Set(presetCollection ? [presetCollection] : []),
    weights: new Set(),
    purities: new Set(),
    priceBands: new Set(),
    tag: presetTag || null,
    min: presetMin != null && presetMin !== "" ? +presetMin : null,
    max: presetMax != null && presetMax !== "" ? +presetMax : null,
    sort: presetSort || "featured",
    view: "3",
    expanded: { collections: false, price: false, weight: false, purity: false },
  };

  /* Skeleton tiles rather than a line of text, so the page holds its shape
     while the catalog loads. Deliberately no shimmer sweep: the stillness
     reads more expensive, and a shimmer would be one more infinite animation. */
  /* The server-rendered first page (collection.liquid) already shows real
     products, so it stays up until the full catalog replaces it; skeletons
     are only for pages that arrive empty (wishlist, filtered views). */
  const results = $("[data-results]");
  const ssrUseful = results.children.length && !wishlistMode &&
    !presetTag && presetMin == null && presetMax == null && !presetCollection;
  if (!ssrUseful) results.innerHTML =
    '<span class="visually-hidden" role="status">Loading catalog</span>' +
    '<div class="card-skeleton" aria-hidden="true"></div>'.repeat(8);

  ZARWANA.ready.then(setup);

  function setup() {
    /* ---------- discover filter facets (rows are painted by renderFilters) ---------- */
    /* Weight/size is internal-only and never surfaced to customers, so the
       weight filter facet is intentionally not rendered (the DOM group was
       removed from catalog.html). */
    hasWeightData = false;
    PURITIES = [...new Set(ZARWANA.products.flatMap((p) => p.purities))];

    let scopeHandle = null;
    /* map a real Shopify collection handle to the closest derived category */
    if (!presetCollection && pathHandle && pathHandle !== "all" && pathHandle !== "frontpage") {
      const norm = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
      /* Shopify suffixes duplicate handles ("earrings-1"), so drop a trailing
         -N before matching or the landing page shows the whole catalog. */
      const target = norm(pathHandle.replace(/-\d+$/, ""));
      const hit = ZARWANA.collections.find((c) =>
        norm(c.key) === target || norm(c.key) === target + "s" ||
        norm(c.key) + "s" === target || norm(c.name) === target);
      if (hit) { presetCollection = hit.key; state.collections.add(hit.key); }
      /* No derived category for this handle (anklets, payal, bali, ...): scope
         the grid to the Shopify collection's own products instead of showing
         the whole catalog under a "Payal" heading. */
      else scopeHandle = pathHandle;
    }

    /* A facet with a single value filters nothing; every piece is 92.5, so
       the group is only noise until a second purity exists. */
    const purityGroup = $("[data-f-purity]") && $("[data-f-purity]").closest(".filter-group");
    if (purityGroup) purityGroup.hidden = PURITIES.length < 2;

    /* ---------- reflect URL-driven filters in the controls ---------- */
    if (state.min != null) $("[data-f-min]").value = state.min;
    if (state.max != null) $("[data-f-max]").value = state.max;
    if (state.sort !== "featured") { const s = $("[data-sort]"); if (s) s.value = state.sort; }

    const start = () => { bindEvents(); render(); };
    if (scopeHandle) loadCollectionHandles(scopeHandle).then(start);
    else start();
  }

  /* ---------- per-dimension predicates ---------- */
  const inBand = (p, b) => p.weight >= b.min && p.weight < b.max;
  const inPriceBand = (p, b) => p.price >= b.min && p.price < b.max;

  /* With no category chosen the catalog is jewellery only: silver articles and
     coins show when asked for by name, in the wishlist, or on their own
     Shopify collection page, never by default. */
  function passCollections(p) {
    if (state.collections.size) return state.collections.has(p.collection);
    return wishlistMode || !!onlyHandles || ZARWANA.isJewellery(p.collection);
  }

  /* "Featured" order. Catalog order is import order, which ran every piece of
     one type before the next. Deal the categories out in turn instead, in the
     house order, so the first screens show the range of the collection. Order
     within a category is untouched. */
  function curate(list) {
    const queues = new Map();
    list.forEach((p) => { (queues.get(p.collection) || queues.set(p.collection, []).get(p.collection)).push(p); });
    const order = [...queues.keys()].sort((a, b) => ZARWANA.categoryRank(a) - ZARWANA.categoryRank(b));
    const out = [];
    while (out.length < list.length)
      order.forEach((k) => { const q = queues.get(k); if (q.length) out.push(q.shift()); });
    return out;
  }
  function passWeight(p) { return !state.weights.size || [...state.weights].some((i) => inBand(p, WEIGHT_BANDS[i])); }
  function passPurity(p) { return !state.purities.size || p.purities.some((pu) => state.purities.has(pu)); }
  function passPrice(p) {
    const bandsOn = state.priceBands.size > 0;
    const customOn = state.min != null || state.max != null;
    if (!bandsOn && !customOn) return true;                                  // no price filter
    const hitBand = bandsOn && [...state.priceBands].some((i) => inPriceBand(p, PRICE_BANDS[i]));
    const hitCustom = customOn && (state.min == null || p.price >= state.min) && (state.max == null || p.price <= state.max);
    return hitBand || hitCustom;                                             // presets and custom range unite (OR)
  }

  /* "New Arrivals" is linked from the main nav and the footer, so it must never
     be a dead end. Prefer products explicitly tagged `new`; if the catalog has
     no such tag yet, fall back to the most recently created products, which is
     what a shopper actually means by "new arrivals". `bestseller` has no
     equivalent automatic signal (it needs order data), so it stays tag-driven
     and render() explains the empty result instead. */
  const NEW_FALLBACK_COUNT = 60;
  const anyTagged = (t) => ZARWANA.products.some((p) => p.tag === t);
  function newestFirst(list) {
    return [...list].sort((a, b) => {
      const ta = a.createdAt ? Date.parse(a.createdAt) : NaN;
      const tb = b.createdAt ? Date.parse(b.createdAt) : NaN;
      if (isNaN(ta) && isNaN(tb)) return 0;
      if (isNaN(ta)) return 1;
      if (isNaN(tb)) return -1;
      return tb - ta;
    });
  }

  /* wishlist + tag always apply; they scope every facet count too */
  /* Handles of the products in the current Shopify collection, when it has
     no derived-category match; null means "no such scoping". Read from the
     public /products.json endpoint, 250 per page. On any failure it stays
     null and the page falls back to the full catalog, as before. */
  let onlyHandles = null;
  async function loadCollectionHandles(handle) {
    try {
      const set = new Set();
      for (let page = 1; page <= 20; page++) {
        const r = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
        if (!r.ok) throw new Error(r.status);
        const batch = (await r.json()).products || [];
        batch.forEach((x) => set.add(x.handle));
        if (batch.length < 250) break;
      }
      onlyHandles = set;
    } catch (e) { onlyHandles = null; }
  }

  function baseList() {
    let list = [...ZARWANA.products];
    if (onlyHandles) list = list.filter((p) => onlyHandles.has(p.id));
    if (wishlistMode) list = list.filter((p) => ZWish.has(p.id));
    if (state.tag === "new" && !anyTagged("new")) list = newestFirst(list).slice(0, NEW_FALLBACK_COUNT);
    else if (state.tag) list = list.filter((p) => p.tag === state.tag);
    return list;
  }

  /* ---------- filtering ---------- */
  function filtered() {
    const list = baseList().filter((p) => passCollections(p) && passPrice(p) && passWeight(p) && passPurity(p));
    switch (state.sort) {
      case "name": list.sort((a, b) => a.name.localeCompare(b.name)); break;
      case "price-asc": list.sort((a, b) => a.price - b.price); break;
      case "price-desc": list.sort((a, b) => b.price - a.price); break;
      default: return state.tag === "new" ? list : curate(list);   // new arrivals stay newest first
    }
    return list;
  }

  /* ---------- faceted counts: each facet counts against every OTHER active filter ---------- */
  function facetCounts() {
    const base = baseList();
    const pool = (skip) => base.filter((p) =>
      (skip === "c" || passCollections(p)) &&
      (skip === "p" || passPrice(p)) &&
      (skip === "w" || passWeight(p)) &&
      (skip === "u" || passPurity(p)));
    const cPool = pool("c"), pPool = pool("p"), wPool = pool("w"), uPool = pool("u");
    return {
      collection: (k) => cPool.reduce((n, p) => n + (p.collection === k), 0),
      priceBand: (b) => pPool.reduce((n, p) => n + inPriceBand(p, b), 0),
      weightBand: (b) => wPool.reduce((n, p) => n + inBand(p, b), 0),
      purity: (pu) => uPool.reduce((n, p) => n + p.purities.includes(pu), 0),
    };
  }

  /* ---------- paint one facet group: counts, hide-empties, "N more" ---------- */
  function renderOptions(container, group, attr, items) {
    if (!container) return;
    const visible = items.filter((it) => it.count > 0 || it.checked);       // keep checked rows even at 0
    const shown = state.expanded[group] ? visible : visible.slice(0, MORE_LIMIT);
    let html = shown.map((it) =>
      `<label class="check-row"><input type="checkbox" ${attr} value="${it.value}"${it.checked ? " checked" : ""}/>` +
      `<span class="opt-label">${it.label}</span><span class="opt-count">${it.count}</span></label>`).join("");
    if (visible.length > MORE_LIMIT)
      html += `<button type="button" class="opt-more" data-more data-group="${group}" data-open="${state.expanded[group] ? 1 : 0}">` +
        (state.expanded[group] ? "Show less" : `${visible.length - MORE_LIMIT} more`) + `</button>`;
    container.innerHTML = html || `<p class="opt-empty">None available</p>`;
  }

  function renderFilters() {
    const c = facetCounts();
    renderOptions($("[data-f-collections]"), "collections", "data-fc",
      [...ZARWANA.jewelleryCollections(), ...ZARWANA.houseCollections()].map((col) => ({ value: col.key, label: col.name, count: c.collection(col.key), checked: state.collections.has(col.key) })));
    renderOptions($("[data-f-price-bands]"), "price", "data-fb",
      PRICE_BANDS.map((b, i) => ({ value: i, label: b.label, count: c.priceBand(b), checked: state.priceBands.has(i) })));
    if (hasWeightData) renderOptions($("[data-f-weight]"), "weight", "data-fw",
      WEIGHT_BANDS.map((b, i) => ({ value: i, label: b.label, count: c.weightBand(b), checked: state.weights.has(i) })));
    renderOptions($("[data-f-purity]"), "purity", "data-fp",
      PURITIES.map((pu) => ({ value: pu, label: pu, count: c.purity(pu), checked: state.purities.has(pu) })));
  }

  /* ---------- heading + category rail follow the current selection ---------- */
  const ssrTitle = $("[data-plp-title]").textContent;
  function renderHead() {
    const one = state.collections.size === 1 ? ZARWANA.collections.find((c) => state.collections.has(c.key)) : null;
    let title = ssrTitle;
    if (wishlistMode) title = "Your Wishlist";
    else if (one) title = one.name;
    else if (state.tag === "new") title = "New Arrivals";
    else if (state.tag === "bestseller") title = "Bestsellers";
    else if (presetMin != null || presetMax != null) title = "Shop by Price";
    else if (!onlyHandles) title = "All Jewellery";
    $("[data-plp-title]").textContent = title;

    const rail = $("[data-plp-cats]");
    if (!rail) return;
    if (wishlistMode || onlyHandles) { rail.hidden = true; return; }
    const link = (key, label, on) =>
      `<button type="button" class="plp-cat${on ? " is-active" : ""}" data-cat="${key}"${on ? ' aria-current="true"' : ""}>${label}</button>`;
    rail.innerHTML = link("", "All", !state.collections.size) +
      ZARWANA.jewelleryCollections().map((c) => link(c.key, c.name, !!one && one.key === c.key)).join("");
  }

  function render() {
    renderFilters();
    renderHead();
    const list = filtered();
    const grid = $("[data-results]");
    const ssrPages = $("[data-ssr-pages]");            // crawler pagination; the live grid shows everything
    if (ssrPages) ssrPages.remove();
    grid.classList.toggle("cols-3", state.view === "3");
    /* Cross-fade the swap instead of blinking. The class add and the innerHTML
       assignment happen in the same task, so nothing paints between them: the
       net effect is a clean fade-IN of the new results. */
    grid.classList.add("is-swapping");
    grid.innerHTML = list.map((p) => ZCard(p, { boxed: false })).join("");
    requestAnimationFrame(() => grid.classList.remove("is-swapping"));
    $("[data-count]").textContent = `${list.length} piece${list.length === 1 ? "" : "s"}`;
    const noRes = $("[data-no-results]");
    noRes.style.display = list.length ? "none" : "block";
    /* An empty grid must always say why, and offer a way out. The default copy
       talks about price because that is the usual cause, but it is wrong for
       the wishlist and for Bestsellers. */
    if (!list.length) {
      if (wishlistMode)
        noRes.textContent = "Your wishlist is empty. Tap the heart on any piece to save it here.";
      else if (onlyHandles && !onlyHandles.size)
        noRes.innerHTML = 'Nothing in this collection right now. <a href="/collections/all">Browse all jewellery</a>.';
      else if (state.tag === "bestseller")
        noRes.innerHTML = 'Our bestsellers are still being curated. <a href="/collections/all">Browse the full collection</a> in the meantime.';
      else
        noRes.textContent = "Nothing matches those filters yet. Try widening the price range.";
    }
  }

  /* ---------- events (bound once, after real filter options exist) ------- */
  function bindEvents() {
    document.addEventListener("change", (e) => {
      if (e.target.matches("[data-fc]")) { e.target.checked ? state.collections.add(e.target.value) : state.collections.delete(e.target.value); render(); }
      if (e.target.matches("[data-fw]")) { e.target.checked ? state.weights.add(+e.target.value) : state.weights.delete(+e.target.value); render(); }
      if (e.target.matches("[data-fp]")) { e.target.checked ? state.purities.add(e.target.value) : state.purities.delete(e.target.value); render(); }
      if (e.target.matches("[data-fb]")) { e.target.checked ? state.priceBands.add(+e.target.value) : state.priceBands.delete(+e.target.value); render(); }
      if (e.target.matches("[data-sort]")) { state.sort = e.target.value; render(); }
    });
    /* "N more" / "Show less" toggles per group (rows are re-painted each render) */
    document.addEventListener("click", (e) => {
      const catBtn = e.target.closest("[data-cat]");
      if (catBtn) {
        state.collections.clear();
        if (catBtn.dataset.cat) state.collections.add(catBtn.dataset.cat);
        render();
        return;
      }
      const more = e.target.closest("[data-more]");
      if (more) { state.expanded[more.dataset.group] = !state.expanded[more.dataset.group]; render(); }
    });
    let priceTimer;
    document.addEventListener("input", (e) => {
      if (e.target.matches("[data-f-min],[data-f-max]")) {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(() => {
          state.min = $("[data-f-min]").value ? +$("[data-f-min]").value : null;
          state.max = $("[data-f-max]").value ? +$("[data-f-max]").value : null;
          render();
        }, 350);
      }
    });
    $("[data-f-clear]").addEventListener("click", () => {
      state.collections.clear(); state.weights.clear(); state.purities.clear(); state.priceBands.clear();
      state.min = state.max = null;
      Object.keys(state.expanded).forEach((g) => (state.expanded[g] = false));
      $("[data-f-min]").value = ""; $("[data-f-max]").value = "";
      render();  // repaints all facet rows unchecked
    });
    $$("[data-view]").forEach((b) => b.addEventListener("click", () => {
      state.view = b.dataset.view;
      $$("[data-view]").forEach((x) => x.classList.toggle("active", x === b));
      render();
    }));

    /* mobile filter drawer */
    ZOverlay.register("filters", $("[data-plp-filters]"));
    $("[data-open-filters]").addEventListener("click", () => {
      $("[data-filters-close]").style.display = "inline-flex";
      ZOverlay.open("filters");
    });

    /* re-render wishlist view when hearts toggle */
    if (wishlistMode) document.addEventListener("click", (e) => {
      if (e.target.closest("[data-wish]")) setTimeout(render, 50);
    });
  }
})();
